import styled from "@yb/styled-px2rem";
import imgButton from "@PUBLIC/M/images/btn/btn_spr.png";
import imgIcon from "@PUBLIC/M/images/ico/ico_spr.png";
import {Ellipsis} from "../text";

const FilterHeader = styled.div`
	position: sticky;
	top: 0;
	background-color: #fff;
	z-index: 5;
`;

const FilterTop = styled.div`
	display: flex;
	height: 50px;
	border-bottom: 1px solid var(--line-color);
	background-color: #fff;
	justify-content: space-between;
	align-items: center;
`;

const FilterLeftBox = styled.div`
	padding-left: 15px;
	font-size: 15px;
	em {
		color: var(--blue-color);
	}
`;

const SelectBox = styled.div`
	position: relative;
	display: flex;
	cursor: pointer;
	-webkit-box-pack: justify;
	justify-content: space-between;

	select {
		width: auto;
		height: 100%;
		padding-right: 30px;
		border: none;
		letter-spacing: -0.1em;
		background-color: transparent;
		color: var(--emp-color);
		font-family: "PT-regular";
		text-align: right;
	}

	&:after {
		position: absolute;
		right: 15px;
		top: 19px;
		width: 5px;
		height: 5px;
		border-top: 1px solid #1d1d1d;
		border-right: 1px solid #1d1d1d;
		background-color: transparent;
		transform: rotate(135deg);
		content: "";
	}
`;

const FilterButton = styled.button`
	display: flex;
	border-left: 1px solid var(--line-color);
	background-color: transparent;
	font-size: 15px;
	font-family: "PT-regular";
	align-items: center;
	gap: 5px;

	&:before {
		display: inline-flex;
		width: 15px;
		height: 15px;
		background: transparent url(${imgIcon}) 0 0 / 300px 300px;
		content: "";
	}
`;

const FilterRightBox = styled.div`
	display: flex;
	height: 100%;

	select {
		height: 100%;
		border: none;
		font-size: 15px;
	}

	button {
		padding: 0 15px 0 10px;
	}
`;

const TagContainer = styled.div`
	display: flex;
	position: relative;
	height: 50px;
	padding-left: 15px;
	background: var(--disabled-color);
	align-items: center;
	z-index: 1;
`;

const ResetButton = styled.button`
	display: flex;
	width: 35px;
	height: 35px;
	margin-right: 15px;
	border-radius: 50%;
	background-color: #fff;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;

	&:after {
		display: block;
		width: 14px;
		height: 14px;
		background: transparent url(${imgButton}) -16px -16px / 100px 100px;
		content: "";
	}
`;

const FilterTagWrap = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	overflow-x: scroll;
	overflow-y: hidden;
	white-space: nowrap;

	&::-webkit-scrollbar-track {
		width: 0;
		height: 0;
		background-color: transparent;
	}
	&::-webkit-scrollbar {
		width: 0;
		height: 0;
		background-color: transparent;
	}
	&::-webkit-scrollbar-thumb {
		width: 0;
		height: 0;
		background-color: transparent;
	}
`;

const FilterTag = styled.button`
	position: relative;
	display: inline-flex;
	margin-right: 12px;
	background-color: transparent;
	color: var(--default-color);
	font-size: 15px;
	align-items: center;

	i {
		display: block;
		position: relative;
		width: 12px;
		height: 12px;
		margin-left: 5px;
		font-size: 0;

		&:before,
		&:after {
			position: absolute;
			top: 5px;
			left: 0;
			right: 0;
			height: 1px;
			background: #7c7c7c;
			content: "";
		}

		&:before {
			transform: rotate(45deg);
		}

		&:after {
			transform: rotate(-45deg);
		}
	}
`;

const BoxWrap = styled.div<{width?: string}>`
	display: flex;
	width: ${props => props.width || "100%"};
	align-items: center;
	background-color: #fff;
	color: #555;
	box-sizing: border-box;

	input {
		font-size: 13px;
	}
`;

const OptionItem = styled.li<{width?: string}>`
	height: 100%;
	outline: 1px solid var(--line-color);
	cursor: pointer;

	input[type="checkbox"] {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}

	label {
		display: block;
		height: 40px;
		color: var(--default-color);
		line-height: 40px;
		${Ellipsis(1)}
	}

	input[type="checkbox"]:checked + label {
		font-weight: bold;
		color: var(--emp-color);
		background-color: var(--yellow-color);
	}

	span {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		color: var(--bl-color);
		cursor: auto;
	}

	${props =>
		props.width &&
		`
        border-bottom: none;
        border-right: 1px solid var(--line-color);
        flex: 1 1 ${props.width};
        justify-content: center;

        &:last-child {
            border-right: none;
        }

        > label {
            padding-left: 0;
            justify-content: center;
            text-align: center;
        }
    `}
`;

const GridList = styled.ul<{columns?: string}>`
	display: grid;
	margin: 0 1px;
	grid-template-columns: ${props => props.columns};
	grid-gap: 1px;

	li {
		border: none;
		outline: 1px solid var(--line-color);
		text-align: center;
	}
`;

export {
	FilterHeader,
	FilterTop,
	FilterLeftBox,
	FilterButton,
	SelectBox,
	FilterRightBox,
	TagContainer,
	ResetButton,
	FilterTagWrap,
	FilterTag,
	BoxWrap,
	OptionItem,
	GridList,
};
